import axios from 'axios'

const state = {
  technicalCardsList: [],
  technicalCardsSingle: null,
}

const getters = {
  getTechnicalCardsList (state) {
    return state.technicalCardsList
  },
  getTechnicalCardsSingle (state) {
    return state.technicalCardsSingle
  },
}

const mutations = {
  setTechnicalCardsList (state, payload) {
    state.technicalCardsList = payload
  },
  setTechnicalCardsSingle (state, payload) {
    state.technicalCardsSingle = payload
  },
  clearTechnicalCardsSingle (state) {
    state.technicalCardsSingle = null
  },
}

const actions = {
  fetchTechnicalCardsList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/technicalCardsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setTechnicalCardsList', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchSingleTechnicalCards ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/technicalCardsSingle'](id))
      .then((res) => {
        commit('setTechnicalCardsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createTechnicalCards ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/technicalCardsCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editTechnicalCards ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/technicalCardsEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteTechnicalCards ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/technicalCardsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getTechnicalCardsList.filter(
            (val) => val.id !== id,
          )
          commit('setTechnicalCardsList', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
